/**
 * Resolves a category/subcategory's display name for the active locale.
 *
 * Category names come from the backend as a language-keyed object, e.g.
 * `{ en: "Development", uk: "Розробка", es: "Desarrollo" }`. The UI used to
 * hardcode `name.en`; this helper picks the active locale instead and falls
 * back gracefully when a translation is missing.
 *
 * Fallback order: requested locale → English → first available value → ''.
 */
export const getLocalizedCategoryName = (
  name: { [key: string]: string } | undefined | null,
  locale?: string
): string => {
  if (!name) return ''

  if (locale && name[locale]?.trim()) return name[locale]
  if (name.en?.trim()) return name.en

  const firstAvailable = Object.values(name).find((value) => value?.trim())
  return firstAvailable || ''
}
